import { type UseQueryResult, useQuery } from 'react-query';
import {
  TotpEnrollmentService,
  // eslint-disable-next-line camelcase
  type WealthlaneDtos_Totps_TotpEnrollmentIsAuthenticatorDeviceRegisteredResponseDto,
} from '../../services/wealthlane-identity-services';

const useGetIsAuthenticatorDeviceRegistered = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  WealthlaneDtos_Totps_TotpEnrollmentIsAuthenticatorDeviceRegisteredResponseDto | undefined,
  unknown
> => {
  return useQuery(['getIsAuthenticatorDeviceRegistered'], async () => {
    return await handleRequest(
      TotpEnrollmentService.getApiIdentityApiTotpEnrollmentIsAuthenticatorDeviceRegistered()
    );
  });
};

export default useGetIsAuthenticatorDeviceRegistered;
